import { Injectable } from '@angular/core';
import { QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { VatRateForSaleWstoQuery, VatRateForSaleWstoQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(VatRateForSaleWstoQuery)
@Wrapper(VatRateForSaleWstoQueryHandlerBase)
export class VatRateForSaleWstoQueryHandler {
    public constructor(
        rootContext: RootContext
    ) { }
}
